/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (renders the min/max age-range label for a product)
 *   extends:   Component (@glimmer/component)
 *   template:  human-age.hbs
 *   args:      @min, @max
 *   uses:      service intl
 *   siblings:  -
 *   tests:     glimmer-actions-test.js, app-logic-test.js
 *
 * Formats an age-range string ("starting from N", "up to N", or "from N to M")
 * from @min/@max using intl translations.
 */
import Component from '@glimmer/component';

import { inject as iService } from '@ember/service';

export default class HumanAgeComponent extends Component {
  @iService intl;

  get humanAge() {
    if (this.args.min && this.args.min !== '') {
      if (!this.args.max || this.args.max === '') {
        return `${this.intl.t('starting_from')} ${this.args.min} ${this.intl.t('years')}`;
      }
    }

    if (this.args.max && this.args.max !== '') {
      if (!this.args.min || this.args.min === '') {
        return `${this.intl.t('end_to')} ${this.args.max} ${this.intl.t('years')}`;
      }
    }

    return `${this.intl.t('from_to_age', {
      from: this.args.min,
      to: this.args.max,
    })}`;
  }
}
